import TaxPayer from "../models/tax-payer";

const selectionKey = (userId: number) => `selectedTaxPayerId:${userId}`;

export const loadSelectedTaxPayer = (
  userId: number,
  companies: TaxPayer[],
): TaxPayer | undefined => {
  let savedId: number | undefined;
  try {
    const stored = window.localStorage.getItem(selectionKey(userId));
    if (stored !== null) savedId = Number(stored);
  } catch {
    // Selection still works when browser storage is unavailable.
  }
  return companies.find((company) => company.id === savedId) || companies[0];
};

export const rememberSelectedTaxPayer = (
  userId: number,
  taxPayerId: number,
): void => {
  try {
    window.localStorage.setItem(selectionKey(userId), String(taxPayerId));
  } catch {
    // The in-memory selection remains usable.
  }
};
